import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle, XCircle, CircleNotch } from "@phosphor-icons/react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        setStatus(data);
        if (data.payment_status === "paid" || data.payment_status === "failed") return;
        if (attempts < 10) {
          setTimeout(() => setAttempts((a) => a + 1), 2000);
        }
      } catch (_e) {}
    };
    poll();
  }, [sessionId, attempts]);

  const paid = status.payment_status === "paid";
  const failed = status.payment_status === "failed";
  const pending = !paid && !failed;

  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="max-w-md w-full border border-border bg-card p-10 text-center">
        {pending && (
          <>
            <CircleNotch size={40} className="mx-auto animate-spin text-primary" />
            <h1 className="font-serif-display text-3xl mt-6">Verifying Payment</h1>
            <p className="text-sm text-muted-foreground mt-2 num">
              Session {sessionId?.slice(-8)}
            </p>
          </>
        )}
        {paid && (
          <>
            <CheckCircle size={40} weight="fill" className="mx-auto text-primary" />
            <h1 className="font-serif-display text-3xl mt-6">Payment received.</h1>
            <p className="text-sm text-muted-foreground mt-2">
              A receipt journal has been posted to your ledger.
            </p>
          </>
        )}
        {failed && (
          <>
            <XCircle size={40} weight="fill" className="mx-auto text-destructive" />
            <h1 className="font-serif-display text-3xl mt-6">Payment failed.</h1>
          </>
        )}
        <Link
          to="/invoices"
          data-testid="back-to-invoices"
          className="inline-block mt-8 rounded-sm border border-border px-6 py-2 text-xs uppercase tracking-widest font-mono hover:bg-muted transition-colors duration-200"
        >
          Back to Invoices
        </Link>
      </div>
    </div>
  );
}
